export const CompleteCheckSVG = () => {
  return (
    <svg
      className="scale-125"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="11.8333" fill="white" />
      <circle cx="12" cy="12" r="11.8333" fill="#059C2F" fillOpacity="0.05" />
      <circle cx="12" cy="12" r="11.8333" stroke="#059C2F" strokeWidth="0.333333" />
      <g clipPath="url(#clip0_736_10866)">
        <path
          d="M16.1519 9.78906L10.671 15.27L8.17969 12.7786"
          stroke="#059C2F"
          strokeWidth="0.569444"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_736_10866">
          <rect width="9.11111" height="9.11111" fill="white" transform="translate(7.60938 8.08203)" />
        </clipPath>
      </defs>
    </svg>
  );
};
